class ColumnMetric {
    constructor(metricJson) {
        this.range = metricJson.range;
        this.color = metricJson.color;
        this.plotAsBand = metricJson.plotAsBand || false;
    }
    toJson() {
        return {
            range: this.getRange(),
            color: this.getColor(),
            plotAsBand: this.getPlotAsBand(),
        };
    }
    getRange() {
        return this.range;
    }
    getColor() {
        return this.color;
    }
    getPlotAsBand() {
        return this.plotAsBand;
    }
    isValueInRange(value) {
        return value >= this.range.min && value < this.range.max;
    }
}
export class MetricDefinition {
    constructor(row) {
        this.row = row || [];
    }
    getRow() {
        return this.row;
    }
}
export class ColumnMetricsDefinition {
    constructor(metricDefinitionJson) {
        metricDefinitionJson.row = metricDefinitionJson.row || [];
        this.metrics = metricDefinitionJson.row.map(metricJson => {
            return new ColumnMetric(metricJson);
        });
    }
    getMetrics() {
        return this.metrics;
    }
    getMetricAtIndex(index) {
        if (index < 0 || index >= this.metrics.length) {
            return null;
        }
        return this.metrics[index];
    }
    getColorForValue(value) {
        const metric = this.metrics.find(columnMetric => {
            return columnMetric.isValueInRange(value);
        });
        return !!metric && !metric.plotAsBand ? metric.getColor() : null;
    }
}
//# sourceMappingURL=column-metrics.js.map